var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('section',{staticClass:"spend",class:{ active: _setup.cookie }},[_c('div',[_vm._t("default"),_c('img',{attrs:{"src":require("@/assets/icons/cancel.svg"),"loading":"lazy","height":"32","width":"32","alt":""},on:{"click":function($event){(_vm.$store.state.saveOn = false), _setup.close()}}})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }